import { Show, useModal } from "@refinedev/antd";
import { Space, Button, Tag, Input } from "antd";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import {
  DesktopOutlined,
  RocketOutlined,
} from "@ant-design/icons";

import { IEcdis } from "interfaces";
import prettyBytes from "pretty-bytes";
import React from "react";
import {
  ShowField,
  ShowSection,
  ShowFieldGrid,
  ShowModal,
} from "components/show";

export const EcdisShow: React.FC<IResourceComponentsProps> = () => {
  const { result, query: { isLoading } } = useShow<IEcdis>();
  const record = result;

  const {
    modalProps: modalPropsVessel,
    show: showVessel,
    close: closeVessel,
  } = useModal();

  const hasVessel = !!record?.vessel;

  return (
    <Show
      breadcrumb={false}
      headerProps={{
        onBack: () => window.history.back(),
        title: "Show ECDIS",
        subTitle: "active ecdis",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
      isLoading={isLoading}
      footerButtons={
        <Space>
          {hasVessel && (
            <Button type="default" onClick={showVessel}>
              Associated Vessel
            </Button>
          )}
        </Space>
      }
    >
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        {/* ECDIS Information */}
        <ShowSection
          title="ECDIS Information"
          subtitle="Electronic Chart Display configuration"
          icon={<DesktopOutlined />}
          variant="elevated"
        >
          <ShowFieldGrid columns={2}>
            <ShowField label="Vessel Name" value={record?.vessel?.name} />
            <ShowField label="IMO Number" value={record?.vessel?.imoNumber} type="code" copyable />
            <ShowField label="UKHO Licence" value={record?.vessel?.licence?.ukhoLicenceId} type="code" copyable />
            <ShowField label="Make" value={record?.make} />
            <ShowField label="Model" value={record?.model} />
          </ShowFieldGrid>
        </ShowSection>
      </Space>

      {/* Vessel Modal */}
      <ShowModal
        title="Vessel Details"
        subtitle={record?.vessel?.name}
        icon={<RocketOutlined />}
        open={modalPropsVessel.open ?? false}
        onClose={closeVessel}
        empty={!hasVessel}
        emptyText="No vessel associated with this ECDIS"
        width={700}
      >
        <Space direction="vertical" size={20} style={{ width: "100%" }}>
          <ShowFieldGrid columns={2}>
            <ShowField label="Vessel Name" value={record?.vessel?.name} />
            <ShowField label="Vessel Type" value={record?.vessel?.type} type="tag" tagColor="blue" />
            <ShowField label="IMO Number" value={record?.vessel?.imoNumber} type="code" copyable />
            <ShowField label="Communication Email" value={record?.vessel?.email} type="email" />
            <ShowField label="Call Sign" value={record?.vessel?.callSign} type="code" />
            <ShowField label="Max Email Size" value={record?.vessel?.maxEmailSizeKb ? prettyBytes(Number(record.vessel.maxEmailSizeKb)) : null} />
            <ShowField label="Max Transmission Size" value={record?.vessel?.maxTransmissionSizeMb ? prettyBytes(Number(record.vessel.maxTransmissionSizeMb) * 1024 * 1024) : null} />
            <ShowField label="Status" value={record?.vessel?.holdStatus} type="status" />
          </ShowFieldGrid>
          {record?.vessel?.notes && (
            <div>
              <ShowField label="Notes" value="" />
              <Input.TextArea rows={4} readOnly value={record?.vessel?.notes} style={{ marginTop: 8 }} />
            </div>
          )}
        </Space>
      </ShowModal>
    </Show>
  );
};
